<template>
  <Block class="password-block">
    <template #header>
      {{ title }}
    </template>

    <md-codebox
      v-bind="$attrs"
      :mask="true"
      :maxlength="6"
      v-on="$listeners"
    />

    <div style="position: relative;">
      <slot name="otp" />
    </div>

    <p v-if="error" class="tc red mt60">{{ error }}</p>
  </Block>
</template>

<script>
import Block from '@/components/Block'
import { Codebox } from 'mand-mobile'

export default {
  name: 'SetPassword',

  components: {
    Block,
    [Codebox.name]: Codebox
  },

  props: {
    error: {
      type: String,
      default: ''
    },

    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.password-block {
  /* stylelint-disable selector-pseudo-element-no-unknown, no-duplicate-selectors */
  ::v-deep .flash-block__content {
    height: 490px;

    .md-codebox-box {
      background: #fff;
      border: 2px solid #e5e5e5;
      border-radius: 10px;
    }
  }
}
</style>
